/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@ember/component';
import { inject as service } from '@ember/service';
import { task } from 'ember-concurrency';
import { action, computed } from '@ember/object';
import DomainModel from 'cio/models/domain';
import DomainVerificationService from 'cio/services/domain-verification';

export default class DomainSetupLinkTracking extends Component {
  @service domainVerification!: DomainVerificationService;

  // external
  domain!: DomainModel;
  onVerify?: () => unknown;

  // internal
  errors: string[] = [];

  @computed('domain.cname')
  get subdomain() {
    let { cname, parentDomain, domain } = this.domain;

    // Extract the subdomain from either the CNAME or domain
    // If a CNAME value is available, use that to find the subdomain:
    //
    //    email.customer.io -> the subdomain is "email"
    //    email.track.customer.io -> the subdomain is "email.track"
    //
    // If there is no CNAME value, use the actual domain. It might be in the
    // following formats:
    //
    //    customer.io -> there is no subdomain here, just use "email".
    //    track.customer.io -> the subdomain is track, use "email.track"
    //
    // This ensures that customers aren't forced to use subdomain of a
    // subdomain and can instead use any subdomain of the parent domain.
    if (cname) {
      return cname.replace(`.${parentDomain}`, '');
    } else if (parentDomain === domain) {
      return 'email';
    } else {
      return `email.${domain.replace(`.${parentDomain}`, '')}`;
    }
  }

  verifyTask = task(async () => {
    try {
      // @ts-ignore
      await this.domainVerification.verifyTask.perform(this.domain, 'link_tracking');

      if (this.onVerify) {
        this.onVerify();
      }
    } catch (errors) {
      this.set('errors', errors);
    }
  });

  @action
  updateSubdomain(subdomain: string) {
    this.domain.set('cname', `${subdomain}.${this.domain.parentDomain}`);
  }
}
